var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 26,
    viewBox: "0 0 38 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68248e-07 13L13 26L13 -5.68248e-07L5.68248e-07 13Z",
    fill: "#F0B211"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 26,
    transform: "translate(13)",
    fill: "#F0B211"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1992 19.5H22.9404L22.958 17.373H25.1992C25.8203 17.373 26.3037 17.2617 26.6494 17.0391C26.9951 16.8164 27.2383 16.4648 27.3789 15.9844C27.5254 15.5039 27.5986 14.874 27.5986 14.0947V12.0996C27.5986 11.5078 27.5605 11.0068 27.4844 10.5967C27.4082 10.1807 27.2793 9.84668 27.0977 9.59473C26.916 9.33691 26.6729 9.14648 26.3682 9.02344C26.0635 8.90039 25.6855 8.83887 25.2344 8.83887H22.8965V6.70312H25.2344C25.9727 6.70312 26.6436 6.82324 27.2471 7.06348C27.8506 7.30371 28.3691 7.65527 28.8027 8.11816C29.2363 8.5752 29.5703 9.14062 29.8047 9.81445C30.0391 10.4883 30.1562 11.2559 30.1562 12.1172V14.0947C30.1562 14.9619 30.0391 15.7295 29.8047 16.3975C29.5703 17.0654 29.2363 17.6309 28.8027 18.0938C28.375 18.5508 27.8564 18.8994 27.2471 19.1396C26.6377 19.3799 25.9551 19.5 25.1992 19.5ZM24.4346 6.70312V19.5H21.8594V6.70312H24.4346Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/d.82e9b165faee05b47f1fba750f850379.svg";
export { ForwardRef as ReactComponent };